const contactUs = {
  title: "NOUS CONTACTER",
  forms: {
    student: "Je suis élève/parent d'élève",
    teacher: "Je suis professeur",
    other: "Autre",
  },
  faq: {
    title: "FAQ",
    sections: {
      password: {
        q: "J'ai oublié mon mot de passe",
        a: "Allez sur votre page de connexion et cliquez sur « mot de passe oublié »",
      },
    },
  },
};

export default contactUs;
